import React from "react"
import {
  ReactUseState,
  IsSearchingContext,
  GridInitializedContext,
  IsRestoreSearchingContext,
} from "../../../../components/Context"

// TODO:API確定後、responseの型に変更
export const SearchResultContext = React.createContext<any[] | undefined>([])

/**
 * 受注配車入力のProvider
 */
export const KaikonZyutyuHaisyaPatternModalProvider: React.FC<{
  isSearching: ReactUseState<boolean>
  isRestoreSearching: ReactUseState<boolean>
  gridInitialized: ReactUseState<boolean>
  SearchResult: Array<Object> | undefined
}> = (props) => {
  return (
    <IsSearchingContext.Provider value={props.isSearching}>
      <SearchResultContext.Provider value={props.SearchResult}>
        <GridInitializedContext.Provider value={props.gridInitialized}>
          <IsRestoreSearchingContext.Provider value={props.isRestoreSearching}>
            {props.children}
          </IsRestoreSearchingContext.Provider>
        </GridInitializedContext.Provider>
      </SearchResultContext.Provider>
    </IsSearchingContext.Provider>
  )
}
